import {CommonService} from '../../services/common.service';
import {Component, OnInit} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {AccessoryCategory} from '../../models/AccessoryCategory';
import {MatSnackBar} from '@angular/material';

@Component({
  selector: 'app-accessory-categories',
  styleUrls: ['./accessory-categories.component.scss'],
  templateUrl: './accessory-categories.component.html'
})
export class AccessoryCategoriesComponent implements OnInit {
  public editedName: string;
  public accessoryCategoriesDataSource: MatTableDataSource<AccessoryCategory>;
  public accessoryCategoriesColumns: string[] = ['description', 'is_active', 'actions'];
  public isEditable: boolean;
  public loading: boolean;
  public newName: string;
  private updateItem: any;

  constructor(private commonService: CommonService,
              private matSnackBar: MatSnackBar) {
    this.isEditable = false;
    this.loading = false;
  }

  async ngOnInit(): Promise<void> {
    await this.getNames();
  }

  async addName() {
    if (this.newName) {
      try {
        const result = await this.commonService.insertObject('accessory/case_types', {description: this.newName});
        this.toastMessages('Ο Κωδικός δημιουργήθηκε με επιτυχία');
        const model = {
          id: result.id,
          description: this.newName,
          is_active: 1
        };
        const data = JSON.parse(JSON.stringify(this.accessoryCategoriesDataSource.data));
        data.push(model);
        this.accessoryCategoriesDataSource.data = data;
        this.resetName();
        this.toastMessages(`Ο Κωδικός δημιουργήθηκε με επιτυχία`);
      } catch (e) {
        this.toastMessages(`Αποτυχία δημιουργίας. Λόγος: ${e.message}`);
      }
    } else {
      this.toastMessages('Το όνομα δεν μπορεί να είναι κενό');
    }
  }

  applyFilterNames(value: any): void {
    this.accessoryCategoriesDataSource.filter = value.trim().toLocaleLowerCase();
  }

  editName(id: any, index: any): void {
    this.isEditable = true;
    this.editedName = this.accessoryCategoriesDataSource.data[index].description;
    this.updateItem = {
      id,
      index,
      description: this.accessoryCategoriesDataSource.data[index].description
    };
  }

  async getNames(): Promise<any> {
    try {
      this.loading = true;
      const data = await this.commonService.getSimpleList('accessory/case_types') as AccessoryCategory[];
      this.accessoryCategoriesDataSource = new MatTableDataSource<AccessoryCategory>(data);
    } catch (e) {
      throw e;
    } finally {
      this.loading = false;
    }
  }

  async updateName(element?: any) {
    if (element) {
      this.updateItem = element;
    }

    const data = JSON.parse(JSON.stringify(this.accessoryCategoriesDataSource.data));
    const updatedItem = data.find(item => item.id === this.updateItem.id);

    const model = {
      id: this.updateItem.id,
      description: element ? element.description : this.editedName,
      is_active: updatedItem.is_active
    };

    if (this.editedName) {
      try {
        await this.commonService.updateObject(`accessory/case_types`, model);
        this.toastMessages('Η ενημέρωση ολοκληρώθηκε με επιτυχία');
      } catch (e) {
        this.toastMessages(`Η ενημέρωση απέτυχε. Λόγος: ${e.message}`);
      }

      const index = this.updateItem.index;
      data[index] = model;
      this.accessoryCategoriesDataSource.data = data;

      this.resetName();
    } else if (element) {
      try {
        const model1 = {
          id: element.id,
          description: element.description,
          is_active: element.is_active ? 0 : 1
        };

        await this.commonService.updateObject(`accessory/case_types`, model1);
        await this.getNames();
        this.toastMessages('Η ενημέρωση ολοκληρώθηκε με επιτυχία');
      } catch (e) {
        this.toastMessages(`Η ενημέρωση απέτυχε. Λόγος: ${e.message}`);
      }
    } else {
      this.toastMessages('Το όνομα δεν μπορεί να είναι κενο');
    }

  }

  resetName(): void {
    this.newName = '';
    this.updateItem = {};
    this.isEditable = false;
    this.editedName = '';
  }

  toastMessages(message: string): void {
    this.matSnackBar.open(message, '', {
      duration: 5000,
    });
  }
}
